import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-clear-circle",
  "use": "icon-clear-circle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-clear-circle\"><path d=\"M512 0C376.661 0 244.992 52.992 149.93 149.93 52.993 244.993 0 376.662 0 512c0 283.392 228.608 512 512 512s512-228.608 512-512S795.392 0 512 0m215.808 727.808c-12.8 12.8-38.4 12.8-51.2 0L512 563.2 347.392 727.808c-12.8 12.8-38.4 12.8-51.2 0a38.912 38.912 0 0 1 0-51.2L460.8 512 296.192 347.392a38.912 38.912 0 0 1 0-51.2c12.8-12.8 38.4-12.8 51.2 0L512 460.8l164.608-164.608c12.8-12.8 38.4-12.8 51.2 0 12.8 12.8 12.8 38.4 0 51.2L563.2 512l164.608 164.608c16.384 12.8 16.384 36.523 0 51.2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/clear-circle.svg
// module id = X63x
// module chunks = 65